export default __webpack_public_path__ + "static/media/1060.6c5b4756.png";